<span class="select-input_text-container" textHiding [tooltipL10n]="displayRec.labelLong || placeholder" [tooltipAlwaysEnabled]="displayRec.labelLong !== displayRec.label">
  <span class="select-input_text">
    {{(displayRec.label || placeholder || '') | l10n}}
  </span>
</span>

@if (isClearBtnVisible) {
  <svg class="select-input_clear-icon"
    (click)="clear($event)">
    <use xlink:href="#small-close"></use>
  </svg>
}

<svg class="select-input_toggle-menu-icon">
  <use xlink:href="#chevron-down"></use>
</svg>
